'use client'

import { useState, useEffect } from 'react'
import ReactPlayer from 'react-player'

interface VideoPlayerProps {
  url: string
}

export const VideoPlayer = ({ url }: VideoPlayerProps) => {
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  return isClient ? (
    <div className="relative aspect-video h-auto w-full overflow-hidden">
      <ReactPlayer
        url={url}
        width="100%"
        height="100%"
        config={{
          youtube: {
            playerVars: {
              controls: 1,
              modestbranding: 1,
              rel: 0,
              showinfo: 0,
              iv_load_policy: 3,
              disablekb: 1,
              fs: 0,
            },
          },
        }}
      />
    </div>
  ) : (
    <div />
  )
}
